import React from 'react';
import { useLocation } from 'react-router-dom'
import { inject, observer } from 'mobx-react';
import DataGrid, { Column, Paging } from 'devextreme-react/data-grid';

import apiUrls from '../../common/api/api-urls';
import { trans } from '../../common/utils';
import { languages } from '../../configs/i18n';
import dataGridDefaultSettings from '../../components/datagrid-settings';
import { Template } from 'devextreme-react/core/template';
import LanguageTemplate from '../../components/language-template';

const MenuEditPage = ({
    store: {
        languages: { table },
    },
}) => {
    return (
        <div className="menu">
            <DataGrid
                {...dataGridDefaultSettings({
                    settingStorageName: 'BMA_grid_menu_main_USERID',
                    url: apiUrls.menu.edit,
                    toolbarCenter: `${useLocation().pathname}`,
                    key: 'menuId',
                    language: languages.languageId[table],
                    editing: {
                        allowDeleting: true,
                        allowUpdating:true,
                        allowAdding:true
                    },
                    editorPreparingArray: ['menuId', 'defaultName'],
                })}
            >
                <Column
                    dataField={'menuId'}
                    caption={trans('ID')}
                    dataType={'number'}
                    width={130}
                    sortOrder={'asc'}
                    allowEditing={false}
                    allowSearch={false}
                />
                <Column
                    dataField={'defaultName'}
                    caption={trans('Название по умолчанию')}
                    dataType={'string'}
                />

                <Column
                    dataField={'name'}
                    caption={trans('Название')}
                    dataType={'string'}
                />

                <Column
                    dataField={'isActive'}
                    caption={trans('Активный?')}
                    dataType={'boolean'}
                    width={150}
                    allowSearch={false}
                />

                <Column
                    dataField={'idt'}
                    caption={trans('Дата вставки')}
                    dataType={'datetime'}
                    format={'dd/MM/yy HH:mm:ss'}
                    width={190}
                    allowEditing={false}
                    allowSearch={false}
                />

                <Column
                    dataField={'udt'}
                    caption={trans('Дата обновления')}
                    dataType={'datetime'}
                    format={'dd/MM/yy HH:mm:ss'}
                    width={190}
                    allowEditing={false}
                    allowSearch={false}
                />
                <Column
                    caption={''}
                    width={50}
                    visible={true}
                    allowFixing={false}
                    allowEditing={false}
                    allowSearch={false}
                    allowHeaderFiltering={false}
                    allowReordering={false}
                    allowHiding={false}
                />
                <Template
                    name={'languageBar'}
                    render={() => <LanguageTemplate />}
                />
                <Paging defaultPageSize={10} enabled />
            </DataGrid>
        </div>
    );
};

export default inject('store')(observer(MenuEditPage));
